<template>
    <label class="flex-form__field" :class="getInvalidClass('result')">
        <div class="flex-form__label">
            Submission Result
        </div>

        <dropdown
            v-model="dataNew.result"
            class="flex-form__dropdown"
            :options="resultOptions"
        />
    </label>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'trigger-flex-event',
    mixins: [eventDataMixin],

    data() {
        return {
            schema: {
                result: {
                    type: String,
                    default: 'success',
                    required: true,
                },
            },

            resultOptions: [
                { text: 'Success', value: 'success' },
                { text: 'Fail', value: 'error' },
            ],
        };
    },
};
</script>
